/* eslint-disable react/style-prop-object */
import React from "react";
import Button from "../../Helpers/Button/Button";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";
import { useNavigate } from "react-router-dom";

export default function AccountHeader({
	inf,
	submitAttempt,
	disable,
	formValidation,
}) {
	const { edit } = usePermission("SETUPACCOUNT");
	const navigate = useNavigate();
	return (
		<div className="account-header border-bottom">
			<div className="flex-between">
				<div className="d-block">
					<div className="fs-24 fw-600 text-capitalize">{trans("Account")}</div>
					<p className="second-header-text">
						{trans("Manage your personal and organization settings.")}
					</p>
				</div>
				{edit && (
					<div className="flex-between">
						<Button
							text={trans("Save Changes")}
							type="primary"
							htmlType="submit"
							disabled={disable || formValidation}
						/>
						<Button
							text={trans("Delete Account")}
							htmlType="button"
							danger={true}
							className="ms-1"
							onClick={() => navigate("/uma-uk-delete-account")}
						/>
					</div>
				)}
			</div>
			{submitAttempt && !inf.isValid ? (
				<div className="validation text-end">
					{trans("Please Check Required Inputs")}
				</div>
			) : (
				""
			)}
		</div>
	);
}